<template>
  <div class="content doc-wrapper">
    <div class="box box--wide document-view">
      <div class="links">
        <button @click="download" class="btn btn--icon"><i class="fas fa-download"></i></button>
        <router-link :to="`/${editURL}/${$route.params.id}`" class="btn btn--icon"><i class="far fa-edit"></i></router-link>
      </div>
      <br>

      <component :is="docType" />

      <br><br>
      <div class="links links--center">
        <button @click="confirmDelete" class="btn btn--icon btn--warn"><i class="far fa-trash-alt"></i></button>
      </div>

      <app-modal ref="confirmDelete">
        <div class="delete-confirm">
          <h1>Na pewno chcesz usunąć fakturę?</h1>
          <small>{{ doc.name }}</small>
          <p>Tej operacji nie da się odwrócić!</p>
          <button class="btn btn--warn" @click="invoiceDelete">Usuń</button>
        </div>
      </app-modal>

    </div>
    <app-loading :active="loading"></app-loading>
  </div>
</template>

<script>

import { api } from '@/api.js'

import Loading from '@/components/Loading.vue'
import Modal from '@/layout/Modal.vue'

import Invoice from '@/components/docs/Invoice.vue'
import WarehouseDoc from '@/components/docs/WarehouseDoc.vue'

export default {
  name: 'app-document',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    doc() {
      return this.$store.state.docs.selectedDoc
    },
    docType() {
      switch (this.doc.type) {
        case 2:
          return 'WarehouseDoc'
        case 1:
        default:
          return 'Invoice'
      }
    },
    editURL() {
      switch (this.doc.type) {
        case 2:
          return 'edit-warehouse-doc'
        case 1:
        default:
          return 'edit-invoice'
      }
    }
  },
  methods: {
    formatCurrency(val) {
      return val.toLocaleString(undefined, {minimumFractionDigits: 2, style: 'currency', currency: this.doc.details.currency})
    },
    async download() {
      this.loading = true
      const response = await api.get(`/docs/${this.$route.params.id}/file`, {
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', `${this.doc.name} - ${this.doc.to.name}.pdf`);
      document.body.appendChild(link);
      link.click();
      this.loading = false
    },
    confirmDelete() {
      this.$refs.confirmDelete.activate()
    },
    async invoiceDelete() {
      try {
        await api.delete(`/docs/${this.$route.params.id}`)
        this.$router.push('/docs')
      } catch(e) {
        console.error(e)
      }
    }
  },
  async created() {
    await this.$store.dispatch('docs/getDocById', this.$route.params.id)
  },
  components: {
    AppLoading: Loading,
    AppModal: Modal,
    Invoice, WarehouseDoc
  },
  metaInfo() {
    return {
      title: this.doc.name
    }
  }
}
</script>

<style lang="scss" scoped>
.document-view {
  padding: 16px;

  .links {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    &--center {
      justify-content: center;
    }
  }
}
</style>
